module.exports = __webpack_public_path__ + "static/media/online_attention.b9b85962.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img1/online_attention.png
// module id = 1654
// module chunks = 0